<div class="topDiv" [style.background-color]="backgroundColorScreen">

    <div class="agGridOuterDiv">
        <div>

          <div class="row topRowMargins headerStyle">

              <div class="vaultobjectDE col-lg-12" style="margin-top: 1%;">

                Multiple Objects Data Extraction

              </div>

          </div>

      </div>

        <div style="margin-top: 25px;">
          <form novalidate [formGroup]='validations_form'>
            <div class="row">
              <div class="col-lg-3"></div>
              <div class="col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFormulaexpression">Extract Name</mat-label>
                  <mat-select matNativeControl (selectionChange)="nameSelection($event)" [(ngModel)]="extractName" formControlName="name" ngDefaultControl required>
                    <mat-option>None</mat-option>
                    <mat-option style="display: flex;">
                      <button i18n="@@TMRunButton" type="button" (click)="addname()" [style.background-color]="buttonColor"
                          class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="margin-left:0;font-size: .80rem;width:100%; text-align: left;">ADD NEW NAME</button>
                    </mat-option>
                    <mat-option *ngFor="let eachname of names"
                      [value]="eachname">
                      {{eachname}}
                    </mat-option>
                  </mat-select>
                   <mat-error *ngFor="let validation of validation_messages.name">
                    <span
                        *ngIf="validations_form.get('name').hasError(validation.type) && (validations_form.get('name').dirty || validations_form.get('name').touched)">
                        {{ validation.message }}
                    </span>
                </mat-error>
                </mat-form-field>
              </div>
          
              <div class="col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFormulaexpression">Database Name</mat-label>
                  <input matInput type="text" placeholder="Database Name" formControlName="databasename" [(ngModel)]="databasename"  maxlength="100" required readonly>
                   <mat-error *ngFor="let validation of validation_messages.databasename">
                    <span
                        *ngIf="validations_form.get('databasename').hasError(validation.type) && (validations_form.get('databasename').dirty || validations_form.get('databasename').touched)">
                        {{ validation.message }}
                    </span>
                </mat-error>
              
                </mat-form-field>
              </div>
              <div class="col-lg-3"></div>

            </div>
          </form>
        </div>

        <div class="row">
            <div class="col-lg-2">

            </div>
          <div class="col-lg-4">
            <div class="seperateDiv" style=" overflow: hidden; flex-grow: 1">
              <ag-grid-angular class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" style="width: 100%;" [columnDefs]="columnDefsForObjects"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="false"
                [rowSelection]="rowSelection" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true"
                (gridReady)="onGridReadyForObjects($event,'insert')" (rowSelected)="cellClickedObjects($event)" (rowDoubleClicked)="pushDataToSelectedFieldsGrid()" [hidden]="!true">
              </ag-grid-angular>
            </div>
          </div>

          <div style="width: 2%;margin: initial;font-size: 1.8rem;text-align: center;">
            <div style="    margin-top: 150px;">
              <div (click)="pushDataToSelectedFieldsGrid()">
                <em class="fas fa-step-forward"></em>
              </div>
              <div (click)="popDataToSelectedFieldsGrid()">
                <em class="fas fa-step-backward"></em>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="seperateDiv">
              <ag-grid-angular class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsForSelectedFields"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="false"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true" [components]="components"
              (gridReady)="onGridReadyForSelectedTableFields($event,ngModelObjectTemporary)" (rowSelected)="onRowSelectedToRemove($event)" (rowDoubleClicked)="popDataToSelectedFieldsGrid()" [hidden]="!true">
              </ag-grid-angular>
            </div>
          </div>

          <div class="col-lg-2">

        </div>
        </div>

            <div style="
            margin-bottom: 2em;"></div>

              <div style="margin-left:2%;margin-right:2%">

                  <div class="col-lg">
                    <div class="container" style="text-align: center;">
                      <div class="row topRowMargins">
                        <div class="col-lg-4"></div>
                        <div class="col-lg-2">
                          <button i18n="@@TMRunButton" type="button" (click)="createreport()" [style.background-color]="buttonColor"
                          class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;" id="114">Extract & Load</button>
                        </div>
                        <div class="col-lg-2">
                          <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="buttonColor"
                          class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
                        </div>
                        <div class="col-lg-4">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <mat-toolbar class="agGridtoperDiv card" style="
                          background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
                  border-right: 1px solid #a9a9a9a8;
                  border-left: 1px solid #a9a9a9a8;">

                              <label i18n="@@spmsUserReg" class="textColour">Vault Object Data Extraction</label>
                              <span class="example-spacer"></span>
                              <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Refresh" (click) = "refresh()">Refresh

                              </button>
                            
                        <div class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>

                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                                <mat-select ngDefaultControl [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                        (click)="onBtPrevious()"></em></li>
                                <li>{{currentpage}}/{{totalpages}}</li>
                                <li class="paginationliicon" style="padding:0;"><em
                                        class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                        </div>
                    </mat-toolbar>
                    </div>
              <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefs"  [animateRows]="true"
              [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
              [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
              [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
              (paginationChanged)="onPaginationChanged()" [components]="components"
              (gridReady)="onGridReady($event)" [hidden]="!true">
              </ag-grid-angular>

      </div>
  </div>
